import { h } from "../shared/safe";
import { platformLabel } from "../../platforms";
import { section, statusPill } from "./bits";
import type { Ctx } from "./context";
import { summariseHosts } from "./derive";

// Which platforms this client can publish to right now. A connection row is not enough: only statuses the publishing
// service resolves count as connected. The rest are listed as needing attention, never as a green dot.

export function renderConnections(ctx: Ctx): HTMLElement {
  const { data } = ctx;
  const s = summariseHosts(data);
  const usable = [...s.usableHosts, ...s.usableOthers];
  const identityOf = (platform: string) => data.connections.find((c) => c.platform === platform && c.usable)?.identity ?? "Connected";
  return section(
    "cd-connections",
    "Connections",
    usable.length === 0
      ? h("p", { class: "muted" }, "Nothing connected for this client yet. ", h("a", { href: "#/connections" }, "Go to Connections"), ".")
      : h(
          "ul",
          { class: "chip-list qf-cd-plain-list", "aria-label": "Connected platforms" },
          ...usable.map((p) => h("li", { class: "chip", title: identityOf(p.platform) }, statusPill("●", "ok"), h("span", { class: "qf-sr-only" }, "Connected: "), platformLabel(p.platform))),
        ),
    s.needsAttention.length
      ? h(
          "ul",
          { class: "chip-list qf-cd-plain-list qf-cd-gap", "aria-label": "Connections needing attention" },
          ...s.needsAttention.map((a) => h("li", { class: "chip" }, statusPill("!", "warn"), platformLabel(a.platform), h("span", { class: "muted" }, ` ${a.status.replace(/_/g, " ")}`))),
        )
      : null,
    h("p", { class: "muted qf-cd-gap" }, `${s.availableToConnect} more platforms available. `, h("a", { href: "#/connections" }, "Manage all connections"), "."),
  );
}
